// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__bfx1v","requiredAsterisk":"Info_requiredAsterisk__e3E77"};